import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog } from "@angular/material/dialog";
import { ConfirmModalComponent } from '@app/shared/confirm-modal/confirm-modal.component'
import { ConfirmDialogData } from '@app/shared/confirm-modal/confirm-modal.model';
import { Observable, BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class GlobalService {
    //mainLoading: boolean = false;
    currentTitlePage: string;
    primaryMenu: boolean = true;
    notificationMessage: any = {
        message: '',
        status: ''
    };
    backgroundColor:string;
    partnerName:string;
    constructor(
        private modal: MatDialog,
        private deviceService: DeviceDetectorService
    ) { }

  private mainLoading = new BehaviorSubject<boolean>(false);
  private loadingCount = 0;

  getMainLoading(): Observable<boolean> {
    return this.mainLoading.asObservable();
  }

  setMainLoading(value: boolean) {
    if (value) {
      this.loadingCount++;
    } else {
      this.loadingCount = Math.max(0, this.loadingCount - 1);
    }
    
    // Solo actualiza el estado si hay un cambio real
    const shouldShowLoader = this.loadingCount > 0;
    if (this.mainLoading.value !== shouldShowLoader) {
      this.mainLoading.next(shouldShowLoader);
    }
  }

  // Método para resetear el contador (útil en casos de error)
  resetLoading() {
    this.loadingCount = 0;
    this.mainLoading.next(false);
  }

  // Método para obtener el estado actual (para casos especiales)
  getLoadingState(): boolean {
    return this.mainLoading.value;
  }

    getCurrentTitlePage() {
        return this.currentTitlePage;
    }

    setCurrentTitlePage(value) {
        this.currentTitlePage = value;
    }

    getNotificationMessage() {
        return this.notificationMessage;
    }

    setNotificationMessage(value) {
        this.notificationMessage = value;
    }

    setBackgroungColor(value){
        this.backgroundColor = value
    }

    getBackgroundColor(){
        return this.backgroundColor;
    }

    setPartnerName(value){
        this.partnerName = value
    }

    getPartnerName(){
        return this.partnerName;
    }

    isMobile(){
        return this.deviceService.isMobile();
    }

    getPrimaryMenu() {
      return this.primaryMenu;
    }
  
    setPrimaryMenu(value:any) {
      this.primaryMenu = value;
    }

    prepareModal(config): Observable<any> {
      return new Observable((observer) => {
        const modalRef = this.modal.open(ConfirmModalComponent, {
          data: {
            title: config.title,
            message: config.message,
          }
        });
        modalRef.afterClosed().subscribe(result => {
          if (result == 'ok') {
            observer.next(result);
            observer.complete();
          }
        });
      })
    }

    showConfirmation(options: ConfirmDialogData): Promise<boolean> {
    const dialogRef = this.modal.open(ConfirmModalComponent, {
      panelClass: 'custom-confirm-dialog',
      data: {
        title: options.title,
        message: options.message,
        confirmText: options.confirmText,
        cancelText: options.cancelText,
        variant: options.variant || 'default',
        icon: options.icon || 'default'
      } as ConfirmDialogData,
    });
    return dialogRef.afterClosed().toPromise();
  }
  
}
